import './manageRoutes';

const ManageRoutes = window.ManageRoutes;

export default ManageRoutes;
